import React, { useContext, useState, useEffect } from "react";
import { StyleSheet, View, Image } from "react-native";

const RemoteImage = ({ uri, desiredWidth }) => {
  const [desiredHeight, setDesiredHeight] = React.useState(0);

  Image.getSize(uri, (width, height) => {
    setDesiredHeight((desiredWidth / width) * height - 2);
  });

  return (
    <Image
      source={{ uri: uri }}
      style={{
        width: desiredWidth,
        height: desiredHeight,
        padding: 5,
      }}
    />
  );
};

export default RemoteImage;
